import { atom } from "recoil";

export const coordinatorDetails = atom({
  key: "coordinatorDetails",
  default: null,
});
